import ReportProblem from '../../../../../pages/vip/features/report-problem/report-problem.desktop';

export default ReportProblem;
